import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c81886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-bottom":"0"} }, null, -1))
const _hoisted_3 = { class: "scrollable-report-card" }
const _hoisted_4 = { class: "nps-display-placeholder" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "report-card-inner" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-height":"100px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonthPicker = _resolveComponent("MonthPicker")!
  const _component_ManagerComment = _resolveComponent("ManagerComment")!
  const _component_NPSDisplay = _resolveComponent("NPSDisplay")!
  const _component_GoalHistory = _resolveComponent("GoalHistory")!
  const _component_ReportCardMessages = _resolveComponent("ReportCardMessages")!
  const _component_AchievedGoal = _resolveComponent("AchievedGoal")!
  const _component_TopPerformer = _resolveComponent("TopPerformer")!
  const _component_TopicFeedbackCarousel = _resolveComponent("TopicFeedbackCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MonthPicker, {
      "month-picker": _ctx.monthPicker,
      "close-popup": _ctx.closePopup,
      onMonthChanged: _ctx.monthChanged
    }, null, 8, ["month-picker", "close-popup", "onMonthChanged"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (
                    _ctx.hasReportCardComment ||
                    (_ctx.isFrontlineManager && _ctx.reportCardUser !== _ctx.userName)
                )
        ? (_openBlock(), _createBlock(_component_ManagerComment, {
            key: 0,
            month: _ctx.reportMonth
          }, null, 8, ["month"]))
        : _createCommentVNode("", true),
      (_ctx.mainScore && _ctx.currentReportData)
        ? (_openBlock(), _createBlock(_component_NPSDisplay, {
            key: 1,
            class: "nps-display",
            score: Number(_ctx.mainScore),
            month: _ctx.reportMonth,
            "score-type": 
                    _ctx.currentReportData ? _ctx.currentReportData.questionType : 'nps'
                ,
            "trigger-from": "report-card",
            "help-text": _ctx.helpText,
            "disable-metric-picker": true
          }, null, 8, ["score", "month", "score-type", "help-text"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
        [_vShow, !_ctx.mainScore]
      ]),
      _createVNode(_component_GoalHistory, { "goal-history": _ctx.reportCardData }, null, 8, ["goal-history"]),
      _hoisted_5,
      _createVNode(_component_ReportCardMessages, {
        title: "Shoutouts",
        "is-loading": _ctx.isLoadingReportCardMessages,
        messages: _ctx.reportCardShoutoutMessages,
        "close-popup": _ctx.closePopup
      }, null, 8, ["is-loading", "messages", "close-popup"]),
      _createVNode(_component_ReportCardMessages, {
        title: "Coaching",
        "is-loading": _ctx.isLoadingReportCardMessages,
        messages: _ctx.reportCardCoachingMessages,
        "close-popup": _ctx.closePopup
      }, null, 8, ["is-loading", "messages", "close-popup"]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.reportMonth)
          ? (_openBlock(), _createBlock(_component_AchievedGoal, {
              key: 0,
              month: _ctx.reportMonth,
              "user-name": _ctx.reportCardUser
            }, null, 8, ["month", "user-name"]))
          : _createCommentVNode("", true),
        (_ctx.showTopPerformer)
          ? (_openBlock(), _createBlock(_component_TopPerformer, {
              key: 1,
              class: "top-performer",
              month: _ctx.reportMonth,
              "user-name": _ctx.reportCardUser
            }, null, 8, ["month", "user-name"]))
          : _createCommentVNode("", true),
        (_ctx.isFrontlineManager)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(_component_TopicFeedbackCarousel, {
          month: _ctx.reportMonth,
          "is-report-card": true,
          "show-empty-topics": false,
          "show-favourites-first": true
        }, null, 8, ["month"]),
        _hoisted_8
      ])
    ])
  ]))
}